module.exports = __webpack_public_path__ + "img/jxs-pos-down-close.21001298.png";